export const STORE_STORAGE_VERSION = "0.3";

export const WALLETCONNECT_CLIENT_ID = "WALLETCONNECT_CLIENT_ID";
